import { FunctionComponent, memo, useMemo } from "react";
import PermissionSummary from "../permissions-list/permission-summary";
import PermissionToggle from "./permission-toggle";
import { permissionIsChecked } from "./permissions-table-body.utilities";
import { IProps } from "./permissions-table-body.types";
import "./permissions-table-body.scss";

/**
 * Show for each role which permissions has assigned
 * @param props.permissions     List of permissions
 * @param props.roles           List of roles
 */
const PermissionsTableBody: FunctionComponent<IProps> = ({ roles, permissions, rolePermissions }) => {
    // Convert array with request results to object
    const roleResults = useMemo(
        () => rolePermissions.reduce((roleDetails, roleResult) => ({ ...roleDetails, ...roleResult }), {}),
        [rolePermissions]
    );

    return (
        <tbody>
            {permissions.map((permission) => (
                <tr key={permission.permissionId}>
                    <th>
                        <PermissionSummary permission={permission} />
                    </th>
                    {roles.map((role) => (
                        <td key={role.roleId}>
                            <PermissionToggle
                                isChecked={permissionIsChecked(roleResults[role.roleId], permission)}
                                role={role}
                                permission={permission}
                            />
                        </td>
                    ))}
                </tr>
            ))}
        </tbody>
    );
};

export default memo(PermissionsTableBody);
